"use client";

import { useMemo } from "react";
import { useT } from "@tillix/i18n/react";
import { type WglT, wglNamespace } from "./index";

export function useWglT(): WglT {
  const { t } = useT(wglNamespace.ns);
  return useMemo(() => wglNamespace.wrap(t), [t]);
}
